import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "h-8" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center ml-auto space-x-1.5 text-muted"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl opacity-80 material-icons-outlined animate-spin" }, " sync ", -1)
const _hoisted_5 = { class: "hidden md:block text-base" }
const _hoisted_6 = {
  key: 1,
  class: "flex items-center ml-auto space-x-1.5 text-muted"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-0.5 text-base"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "flex items-center space-x-1 text-sm text-muted text-danger-dark" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm material-icons-outlined" }, "error_outline", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  class: "fixed rounded-full bg-opacity-90 top-18 right-8 z-999 bg-gray-50"
}
const _hoisted_13 = { class: "opacity-70 shadow-all-around px-3 pt-1.5 pb-1 pr-3 rounded-full" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center ml-auto space-x-1.5 text-muted"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl opacity-80 material-icons-outlined animate-spin" }, " sync ", -1)
const _hoisted_16 = { class: "text-base" }
const _hoisted_17 = {
  key: 1,
  class: "flex items-center ml-auto space-x-1.5 text-muted"
}
const _hoisted_18 = {
  key: 0,
  class: "mb-0.5 text-base"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "flex items-center space-x-1 text-sm text-muted text-danger-dark" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm material-icons-outlined" }, "error_outline", -1)
const _hoisted_22 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", { id: _ctx.elementId }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.saving)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("cloud.saving")), 1)
          ]))
        : (!_ctx.hadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Tooltip, {
                placement: 'left',
                "text-value": _ctx.$t('cloud.changes_saved_to_server')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([{
							'tooltip-handle hover:bg-light hover:bg-opacity-100 rounded px-1.5  transition-colors duration-100':
								!_ctx.showSaved,
						}, "text-xl cursor-default select-none opacity-80 material-icons-outlined hover:text-primary"])
                  }, " cloud_done ", 2)
                ]),
                _: 1
              }, 8, ["text-value"]),
              (_ctx.showSaved)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("cloud.saved")), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cloud.error")), 1)
              ])
            ]))
    ]),
    _createVNode(_Transition, { name: "fade-autosave" }, {
      default: _withCtx(() => [
        (_ctx.showOutOfViewFeedback)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_ctx.saving)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("cloud.saving")), 1)
                    ]))
                  : (!_ctx.hadError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_Tooltip, {
                          placement: 'left',
                          "text-value": _ctx.$t('cloud.changes_saved_to_server')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass([{
									'tooltip-handle hover:bg-light hover:bg-opacity-100 rounded px-1.5  transition-colors duration-100':
										!_ctx.showSaved,
								}, "text-xl cursor-default select-none opacity-80 material-icons-outlined hover:text-primary"])
                            }, " cloud_done ", 2)
                          ]),
                          _: 1
                        }, 8, ["text-value"]),
                        (_ctx.showSaved)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("cloud.saved")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("cloud.error")), 1)
                        ])
                      ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}